import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { CalculatorProvider } from './context/CalculatorContext'

// Check if we should reset the calculator (useful for debugging and first load)
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('reset') === 'true' || !sessionStorage.getItem('appLoaded')) {
  sessionStorage.clear();
  sessionStorage.setItem('appLoaded', 'true');
  sessionStorage.setItem('selectedCalculator', 'home');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CalculatorProvider>
      <App />
    </CalculatorProvider>
  </StrictMode>,
)